/**
 * Locale utility functions for mapping browser locale to currency and country
 */

export const getCurrencyFromLocale = (locale: string): string => {
  // Normalize locale (e.g., 'fr-FR' or 'fr')
  const normalizedLocale = locale.toLowerCase();

  const currencyMap: Record<string, string> = {
    // English variants
    'en': 'USD',
    'en-us': 'USD',
    'en-gb': 'GBP',
    'en-ca': 'CAD',
    'en-au': 'AUD',

    // European countries (EUR)
    'fr': 'EUR',
    'fr-fr': 'EUR',
    'de': 'EUR',
    'de-de': 'EUR',
    'es': 'EUR',
    'es-es': 'EUR',
    'it': 'EUR',
    'it-it': 'EUR',

    // Poland
    'pl': 'PLN',
    'pl-pl': 'PLN',
  };

  return currencyMap[normalizedLocale] || currencyMap[normalizedLocale.split('-')[0]] || 'USD';
};

export const getCountryFromLocale = (locale: string): string => {
  // Extract country code from locale (e.g., 'fr-FR' → 'FR')
  const parts = locale.split('-');

  if (parts.length === 2) {
    return parts[1].toUpperCase();
  }

  // If no country code, map language to common country
  const languageToCountry: Record<string, string> = {
    'en': 'US',
    'fr': 'FR',
    'de': 'DE',
    'es': 'ES',
    'it': 'IT',
    'pl': 'PL',
  };

  return languageToCountry[parts[0].toLowerCase()] || 'US';
};
